/**
 * Created by Karan variya on 27/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { UserDetail } from './UserDetails';
import { DeactiveModel } from './UpdateModel';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class UserDetailsService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    vUserDetails(id): Promise<UserDetail> {
        return this.httpmanagerService.HttpGet('sauserdetails', id).then(data => {
            return data;
        })
    }
    vUserRateReviewDetails(id): Promise<any> {
        return this.httpmanagerService.HttpGet('sauserdetails/appreviewList', id).then(data => {
            return data;
        })
    }
    vWithdrawDetail(id): Promise<any> {
        return this.httpmanagerService.HttpGet('sauserdetails/withdrawhistorylist', id).then(data => {
            return data;
        })
    }
    vLogDetail(data): Promise<any> {
        return this.httpmanagerService.HttpPost('sauserdetails/loghistorylist',JSON.stringify(data) ,"").then(data => {
            return data;
        })
    }
    DeactiveUser(id, data): Promise<DeactiveModel> {
        return this.httpmanagerService.HttpPut('sauserdetails/deactiveuser', JSON.stringify(data), id).then(data => {
            return data
        })
    }
    uDeviceUser(data): Promise<DeactiveModel> {
        return this.httpmanagerService.HttpPut('sauserdetails/changejoincode', JSON.stringify(data), "").then(data => {
            return data
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/userdetails/userdetails.service.ts